import React from 'react';
import Benefits from '../components/Benefits';
import ContactForm from '../components/ContactForm';

export default function BenefitsPage() {
  return (
    <div className="pt-24 lg:pt-32">
      <div className="bg-slate-900 py-16 mb-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-black text-white uppercase tracking-tight mb-4">
            Hvorfor vælge <span className="text-sky-500">KC Detailer?</span>
          </h1>
          <p className="text-slate-400 text-lg max-w-2xl mx-auto">
            Lær mere om de mange fordele ved professionel bilpleje og hvordan vi beskytter din investering.
          </p>
        </div>
      </div>
      <Benefits />
      <ContactForm />
    </div>
  );
}
